import apiClient from "./api"; // Axios instance with auth interceptors

/**
 * Get organization discounts (filtered by ownership)
 */
export const getMyDiscounts = async () => {
  try {
    const response = await apiClient.get("/celebs/organization-discounts");
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Get organization attendees (filtered by ownership)
 */
export const getMyAttendees = async () => {
  try {
    const response = await apiClient.get("/celebs/organization-attendees");
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Get organization tickets (filtered by ownership)
 */
export const getMyTickets = async () => {
  try {
    const response = await apiClient.get("/celebs/organization-tickets");
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Upload event banner/media
 * @param {File} file - The image file
 */
export const uploadMedia = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await apiClient.post("/celebs/upload-media", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Create a new event
 * @param {Object} eventData - Data for the event
 */
export const createEvent = async (eventData) => {
  try {
    const response = await apiClient.post("/celebs/create-event", eventData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Get single event by ID
 */
export const getEventById = async (id) => {
  try {
    const response = await apiClient.get(`/celebs/event/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Update existing event
 */
export const updateEvent = async (id, eventData) => {
  try {
    const response = await apiClient.put(`/celebs/event/${id}`, eventData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Get organization events
 * @param {string} status - Optional status filter (pending, active, cancelled, completed)
 */
export const getMyEvents = async (status = "") => {
  try {
    const response = await apiClient.get("/celebs/organization-events", {
      params: { status },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Create a discount for an event
 * @param {Object} discountData - Data for the discount
 */
export const createDiscount = async (discountData) => {
  try {
    const response = await apiClient.post("/celebs/create-discount", discountData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Get public events
 */
export const getPublicEvents = async () => {
  try {
    const response = await apiClient.get("/celebs/public-events");
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Process event checkout
 * @param {Object} checkoutData - Data for the checkout
 */
export const processCheckout = async (checkoutData) => {
  try {
    const response = await apiClient.post("/celebs/checkout", checkoutData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
